import request from "@/service";

/* 查询题库试题分页列表 */
export function getExamQuestionList(params) {
  return request({
    url: `/study/exam/question/page`,
    method: "get",
    params
  });
}

/* 题库试题新增 */
export function saveQuestion(params) {
  return request({
    url: `/study/exam/question/save`,
    method: "post",
    data: params
  });
}

/* 题库试题详情 */
export function getQuestionInfo(params) {
  return request({
    url: `/study/exam/question/info/${params}`,
    method: "get"
  });
}

/* 题库试题新增 */
export function updateQuestion(params) {
  return request({
    url: `/study/exam/question/update`,
    method: "put",
    data: params
  });
}

/* 题库试题删除 */
export function deleteQuestion(params) {
  return request({
    url: `/study/exam/question/delete`,
    method: "delete",
    data: params
  });
}

/* 关联试卷列表 */
export function getPaperList(params) {
  return request({
    url: `/study/exam/question/paperList/${params}`,
    method: "get"
  });
}

/* 导入试题 */
export function importExamQuestion(params) {
  return request({
    url: `/study/exam/question/import`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

/* 导出试题 */
export function exportExamQuestion(params) {
  return request({
    url: `/study/exam/question/export`,
    method: "get",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    params
  });
}

/* 试题主题列表 */
export function getThemeList() {
  return request({
    url: `/study/exam/question/themeList`,
    method: "get"
  });
}
